"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOnboardingThirdPartyBodyToJSON = exports.CreateOnboardingThirdPartyBodyFromJSONTyped = exports.CreateOnboardingThirdPartyBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function CreateOnboardingThirdPartyBodyFromJSON(json) {
    return CreateOnboardingThirdPartyBodyFromJSONTyped(json, false);
}
exports.CreateOnboardingThirdPartyBodyFromJSON = CreateOnboardingThirdPartyBodyFromJSON;
function CreateOnboardingThirdPartyBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'title': json['title'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
    };
}
exports.CreateOnboardingThirdPartyBodyFromJSONTyped = CreateOnboardingThirdPartyBodyFromJSONTyped;
function CreateOnboardingThirdPartyBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'title': value.title,
        'description': value.description,
    };
}
exports.CreateOnboardingThirdPartyBodyToJSON = CreateOnboardingThirdPartyBodyToJSON;
